import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import {
  FormControl,
  Grid,
  Typography,
  TextField,
  Tab,
  Tabs,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import FormPageHeader from "../utilities/FormPageHeader";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { checkNumber } from "../utilities/FormValidation";
import customStyles from "app/shared-components/SelectCustomStyle";
import CustomDatePicker from "../utilities/CustomDatePicker";
import moment from "moment";
import jwtDecode from "jwt-decode";

const kitchenTypes = [
  "Express Kitchen (Normal Handle)",
  "Express Kitchen (SystemLine)",
  "Nolte Kitchen Non Lacquered",
  "Nolte Kitchen Lacquered",
  "Nolte Eco Non Lacquered",
  "Nolte Eco Lacquered",
  "Nolte Spa Non Lacquered",
  "Nolte Spa Lacquered",
  "Nolte Neo Non Lacquered",
  "Nolte Neo Lacquered",
];

let weekOptions = [];
for (let i = 1; i <= 52; i++) {
  weekOptions.push({ label: i, value: i });
}

const getCurrentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 3 }, (_, index) => {
  const year = getCurrentYear + index;
  return { label: year, value: year };
});

const LogistcsSettings = () => {
  const saveDeliveryInfoUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.saveDeliveryInfo}`;
  const deliveryInfoUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deliveryInfo}`;
  const findByKitchenUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findByKitchen}`;

  const user =
    localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));

  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [error, setError] = useState("");
  // State to store selected values for each product

  const [deliveryDate, setDeliveryDate] = useState(new Date());
  const [kitchenData, setKitchenData] = useState([]);
  const [editKitchenData, setEditKitchenData] = useState({});
  const [kitchenStates, setKitchenStates] = useState({});
  const [saveDisable, setSaveDisable] = useState(false);

  const [kitchenNames, setKitchenNames] = useState(kitchenTypes);
  const navigate = useNavigate();

  const getOrdersByDeliveryDates = async () => {
    const model = {
      kitchenNames: kitchenNames,
      date: deliveryDate,
    };
    try {
      const res = await OAuthService.addData(findByKitchenUrl, model);
      if (res.status === 200) {
        setKitchenData(res?.data);
      } else if (res.status === 204) {
        setKitchenData([]);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleChange = async (data, name) => {
    if (name === "deliveryDate") {
      const deliveryDate = moment(data).format("YYYY-MM-DD");
      setDeliveryDate(deliveryDate);
    }
  };

  const handleSubmit = async () => {
    const requestData = kitchenTypes.map((kitchenType) => ({
      id: kitchenStates[kitchenType].id ? kitchenStates[kitchenType].id : null,
      createdByUser: user.email,
      deliveryDate: deliveryDate,
      kitchenName: kitchenType,
      week: kitchenStates[kitchenType].week,
      year: kitchenStates[kitchenType].year,
    }));

    try {
      const res = await OAuthService.addData(saveDeliveryInfoUrl, requestData);
      if (res.status === 200) {
        setSaveDisable(true);
        setSuccessMsg("Data saved Successfully");
        setSnackState(true);
        // setTimeout(() => {
        //   navigate("/logistics");
        // }, 800);
      }
    } catch (error) {
      setError(error.message);
      return;
    }
  };

  const handleCancel = () => {
    navigate("/logistics");
  };

  useEffect(() => {
    const areAllWeekAndYearNotNull = () => {
      let flag = 0
      for (const kitchenType in kitchenStates) {
        if (kitchenStates.hasOwnProperty(kitchenType)) {
          const { week, year } = kitchenStates[kitchenType];
          if (week || year) {
            if(week && year){
            }else{
              flag++;
            }
          }
        }
      }
      if(flag > 0){
        return true;
      }else{
        return false;
      }
    };
    
    if(editKitchenData){
      if(JSON.stringify(editKitchenData) !== JSON.stringify(kitchenStates)){
        const checkData = areAllWeekAndYearNotNull();
        setSaveDisable(checkData)
      }else{
        setSaveDisable(true)
      }
    }
  }, [kitchenStates]);

  useEffect(() => {
    if (deliveryDate) {
      getOrdersByDeliveryDates();
    }
  }, [deliveryDate]);

  const handleSelectChange = (kitchenType, selectedOption, action, name) => {
    const value = action.action === "clear" ? "" : selectedOption.value;
    const newState = {
      ...kitchenStates,
      [kitchenType]: { ...kitchenStates[kitchenType], [name]: value },
    };
    setKitchenStates(newState);
  };

  useEffect(() => {
    const initialKitchenStates = {};
    kitchenTypes.forEach((kitchenType) => {
      const data = kitchenData.find((item) => item.kitchenName === kitchenType);
      initialKitchenStates[kitchenType] = data
        ? { id: data.id, week: data.week, year: data.year }
        : { id: null, week: null, year: null };
    });
    setKitchenStates(initialKitchenStates);
    setEditKitchenData(JSON.parse(JSON.stringify(initialKitchenStates)))
  }, [kitchenData, deliveryDate]);

  return (
    <div className="w-full">
      <FormPageHeader
        componentName="Logistics Settings"
        // handleDelete={handleDelete}
        handleSubmit={handleSubmit}
        breadCrumbSeperator=">"
        successMsg={successMsg}
        snackState={snackState}
        currentPage={"Logistics Settings"}
        parentBreadcrumbData={[
          { pageName: "Dashboard", pageLink: "/logistics" },
        ]}
        error={error}
        handleCancel={handleCancel}
        // hideDelete={hideDelete}
        saveDisable={saveDisable}
      >
        <Tabs
          value={0}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full h-64 border-b-1" }}
        >
          <Tab 
            className="h-64" 
            label="Basic Info" 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
          />
        </Tabs>
      </FormPageHeader>
      <div className="p-16 sm:p-24 max-w-3xl">
        <FormControl fullWidth>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <label>Incoming Orders From</label>
              <CustomDatePicker
                format={"dd-MM-yyyy"}
                name={"deliveryDate"}
                value={deliveryDate}
                handleChange={(e) => handleChange(e, "deliveryDate")}
              />
            </Grid>
          </Grid>
          <Typography gutterBottom variant="h5" component="div">
            Products
          </Typography>


          <div>
            <Grid container spacing={2}>
              {kitchenTypes.map((kitchenType) => (
                <Grid item xs={6} key={kitchenType}>
                  <label>{kitchenType}</label>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Select
                        className="mb-16"
                        placeholder="Week"
                        name="week"
                        options={weekOptions}
                        onChange={(selectedOption, action) =>
                          handleSelectChange(
                            kitchenType,
                            selectedOption,
                            action,
                            "week"
                          )
                        }
                        value={
                          kitchenStates[kitchenType] &&
                          kitchenStates[kitchenType].week
                            ? {
                                label: kitchenStates[kitchenType].week,
                                value: kitchenStates[kitchenType].week,
                              }
                            : null
                        }
                        isClearable
                        styles={customStyles()}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Select
                        className="mb-16"
                        placeholder="Year"
                        name="year"
                        options={yearOptions}
                        onChange={(selectedOption, action) =>
                          handleSelectChange(
                            kitchenType,
                            selectedOption,
                            action,
                            "year"
                          )
                        }
                        value={
                          kitchenStates[kitchenType] &&
                          kitchenStates[kitchenType].year
                            ? {
                                label: kitchenStates[kitchenType].year,
                                value: kitchenStates[kitchenType].year,
                              }
                            : null
                        }
                        isClearable
                        styles={customStyles()}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </div>
        </FormControl>
      </div>
    </div>
  );
};

export default LogistcsSettings;
